<template>
  <div class="ai-agent">
    <!-- 弹窗：宣传海报 + 选项目/分析（入口卡片见 AiAgentEntry.vue） -->
    <el-dialog
        :visible.sync="visible"
        custom-class="ai-agent-dialog"
        width="680px"
        top="7vh"
        :append-to-body="true"
        :close-on-click-modal="step === 'poster'"
        :destroy-on-close="true"
        @closed="removeDropdownScroll">
      <div class="ai-agent-dialog__body">
        <!-- 第一步：宣传海报，点击进入选择 -->
        <div v-if="step === 'poster'" class="promo-poster">
          <div class="promo-poster__wrap" title="点击体验" @click="step = 'picker'">
            <img :src="poster" class="promo-poster__img" alt="凌博士组学智能体 Pro"/>
          </div>
          <div class="promo-poster__bar">
<!--            <span class="promo-poster__hint">-->
<!--              <i class="el-icon-pointer"></i>-->
<!--              选择项目与分析后即可进入智能体-->
<!--            </span>-->
            <button type="button" class="promo-link-btn" @click="handleNeverShow">不再弹框提示</button>
          </div>
        </div>

        <!-- 第二步：选择项目 + 分析 -->
        <div v-else class="promo-picker" v-loading="loading">
          <div class="promo-picker__head">
            <div>
              <img :src="doctor" class="promo-picker__img" alt="凌博士组学智能体 Pro"/>
            </div>
            <div class="promo-picker__head-text">
              <span class="promo-picker__title">
                凌博士组学智能体 <span class="promo-picker__pro">Pro</span>
              </span>
              <span class="promo-picker__sub">{{ platformTitle }} · 两步即可立即体验</span>
            </div>
          </div>

          <el-form class="promo-picker__form" label-width="80px" @submit.native.prevent>
            <el-form-item label="项目号">
              <template slot="label">
                <span class="addRequired">项目号</span>
              </template>
              <div class="promo-picker__search">
                <el-select
                    v-model="projectSearchField"
                    class="promo-picker__field"
                    popper-class="chat-ai-field-popper"
                    @change="handleSearchFieldChange">
                  <el-option label="项目号" value="projectId"/>
                  <el-option label="合同号" value="contractNumber"/>
                </el-select>
                <el-select
                    v-model="selectedProject"
                    class="promo-picker__select"
                    popper-class="chat-ai-project-popper"
                    filterable
                    remote
                    clearable
                    value-key="projectsRow.projectId"
                    :remote-method="handleProjectSearch"
                    :placeholder="projectPlaceholder"
                    @visible-change="visible => bindDropdownScroll('project', visible)">
                  <template slot="prefix">
                    <i class="el-icon-search promo-picker__searchicon"></i>
                  </template>
                  <el-option
                      v-for="item in projectList"
                      :key="getProjectId(item)"
                      :label="projectLabel(item)"
                      :value="item">
                    <div class="promo-option">
                      <span class="promo-option__main">{{ getProjectId(item) }}</span>
                      <span class="promo-option__meta">
                        <span v-if="getContractNumber(item)" class="promo-option__sub">{{ getContractNumber(item) }}</span>
                        <span v-if="getProjectType(item)" class="promo-option__tag">{{ getProjectType(item) }}</span>
                      </span>
                    </div>
                  </el-option>
                  <!-- 加载状态放在列表底部，不要用 el-select 的 loading（它会把整个列表 v-show 掉） -->
                  <el-option
                      v-if="projectLoading"
                      key="__project_loading__"
                      disabled
                      label="加载中…"
                      value="__project_loading__"/>
                  <el-option
                      v-else-if="projectList.length && !projectNoMore"
                      key="__project_more__"
                      disabled
                      label="上滑加载更多"
                      value="__project_more__"/>
                  <template slot="empty">
                    <div class="promo-select-empty">{{ projectLoading ? '加载中…' : '暂无项目' }}</div>
                  </template>
                </el-select>
              </div>
            </el-form-item>

            <el-form-item label="分析名">
              <template slot="label">
                <span class="addRequired">分析名</span>
              </template>
              <el-select
                  style="width: 100%"
                  ref="analyzeSelect"
                  v-model="analyzeId"
                  popper-class="chat-ai-analyze-popper"
                  filterable
                  remote
                  clearable

                  :disabled="!selectedProject"
                  :remote-method="handleAnalyzeSearch"
                  :placeholder="analyzePlaceholder"
                  @visible-change="visible => bindDropdownScroll('analyze', visible)">
                <el-option
                    v-for="item in analyzeList"
                    :key="getAnalyzeId(item)"
                    :label="analyzeLabel(item)"
                    :value="getAnalyzeId(item)"/>
                <!-- 加载状态放在列表底部，避免 el-select 内置 loading 隐藏整个列表 -->
                <el-option
                    v-if="analyzeLoading"
                    key="__analyze_loading__"
                    disabled
                    label="加载中…"
                    value="__analyze_loading__"/>
                <el-option
                    v-else-if="analyzeList.length && !analyzeNoMore"
                    key="__analyze_more__"
                    disabled
                    label="上滑加载更多"
                    value="__analyze_more__"/>
                <template slot="empty">
                  <div class="promo-select-empty">{{ analyzeLoading ? '加载中…' : '暂无可选分析' }}</div>
                </template>
              </el-select>
              <div v-if="selectedProject && !analyzeLoading && !analyzeList.length" class="promo-picker__tip">
                <i class="el-icon-warning-outline"></i>
                该项目暂无状态为 已完成 的分析，请更换项目
              </div>
            </el-form-item>
          </el-form>


          <div class="promo-picker__footer">
            <div style="text-align: center;flex: 1">
              <el-button
                  size="medium"
                  type="primary"
                  class="promo-picker__enter"
                  icon="el-icon-position"
                  :disabled="!canEnter"
                  @click="enterChatAi">
                进入智能体
              </el-button>
            </div>

          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import poster from '@/assets/chatAiPromo.png'
// 重命名避免与组件内的 projectList / analyzePage（列表与页码）混淆
import {projectList as projectPageList, analyzePage as analyzePageList} from '@/api/project'
import doctor from "@/assets/aiAgentDoctor.png";

// 系统标识 -> 交付系统名称 / web 路由前缀 / 接口平台
// bz 与 bzFun 共用 bz 接口，靠 systemType 区分（diversity / funcGene）
const PLATFORM_INFO = {
  trans: {title: '转录组交付系统', web: 'transWeb', api: 'trans'},
  metabo: {title: '代谢组交付系统', web: 'metaboWeb', api: 'metabo'},
  metag: {title: '宏基因组交付系统', web: 'metagWeb', api: 'metag'},
  bz: {title: '多样性交付系统', web: 'bzWeb', api: 'bz'},
  bzFun: {title: '功能基因扩增子交付系统', web: 'bzWeb', api: 'bz'}
}

// 兼容分页接口的几种返回结构，统一取出 { list, total }
function parsePageResult(res) {
  if (!res || (res.code && res.code !== 200) || !res.data) return {list: [], total: 0}
  const data = res.data
  if (Array.isArray(data)) return {list: data, total: data.length}
  const list = Array.isArray(data.data) ? data.data : (Array.isArray(data.records) ? data.records : [])
  const total = Number(data.totalNum || data.total || list.length)
  return {list, total}
}

export default {
  name: 'AiAgentDrawer',
  props: {
    // 系统标识：trans / metabo / metag / bz / bzFun
    platform: {
      type: String,
      default: 'metabo'
    },
    // bz 平台下区分：diversity / funcGene
    systemType: {
      type: String,
      default: 'diversity'
    }
  },
  data() {
    return {
      poster,
      doctor,
      visible: false,
      step: 'poster',
      pageSize: 20,
      // 项目
      projectList: [],
      projectLoading: false,
      projectKeyword: '',
      // 项目搜索字段：projectId（项目号）/ contractNumber（合同号）
      projectSearchField: 'projectId',
      projectPage: 1,
      projectTotal: 0,
      projectNoMore: true,
      selectedProject: null,
      // 是否勾选“不再自动提示”（仅影响当前弹窗内视觉，实际持久化由父组件处理）
      neverAuto: false,
      // 分析
      analyzeList: [],
      analyzeLoading: false,
      analyzeKeyword: '',
      analyzePage: 1,
      analyzeTotal: 0,
      analyzeNoMore: true,
      analyzeId: '',
      loading: false
    }
  },
  computed: {
    platformTitle() {
      return (PLATFORM_INFO[this.platform] || {}).title || ''
    },
    // 接口使用的平台标识（bzFun 同样走 bz 接口）
    apiPlatform() {
      return (PLATFORM_INFO[this.platform] || {}).api || this.platform
    },
    selectedProjectId() {
      return this.getProjectId(this.selectedProject)
    },
    selectedProjectLabel() {
      const project = this.selectedProject
      if (!project) return ''
      return [this.getProjectId(project), this.getContractNumber(project), this.getProjectType(project)]
          .filter(Boolean)
          .join(' · ')
    },
    projectPlaceholder() {
      return this.projectSearchField === 'contractNumber' ? '输入合同号搜索' : '输入项目号搜索'
    },
    selectedAnalyzeLabel() {
      const item = this.analyzeList.find(it => this.getAnalyzeId(it) === this.analyzeId)
      return (item && this.analyzeLabel(item)) || this.analyzeId
    },
    analyzePlaceholder() {
      return this.selectedProject ? '输入分析号搜索' : '请先选择项目号'
    },
    canEnter() {
      return !!(this.selectedProject && this.analyzeId)
    }
  },
  watch: {
    visible(val) {
      if (!val) this.removeDropdownScroll()
    },
    selectedProject(project) {
      this.analyzeId = ''
      this.analyzeKeyword = ''
      this.analyzeList = []
      this.analyzePage = 1
      this.analyzeTotal = 0
      this.analyzeNoMore = true
      if (project) {
        this.fetchAnalyzes(true)
      }
    },
    analyzeId(val) {
      // 只要分析名有值（自动填充或用户自己选的），之后就不再自动填充
      if (val) this._analyzeAutoFilled = true
      // 选完分析后同样让输入框失焦，去掉文字末尾的光标蓝点
      this.$nextTick(() => {
        const select = this.$refs.analyzeSelect
        if (select && select.blur) select.blur()
      })
    }
  },
  created() {
    this._projectTimer = null
    this._analyzeTimer = null
    this._projectToken = 0
    this._analyzeToken = 0
    this._scrollWrap = null
    this._scrollKind = ''
    this._scrollHandler = this.handleDropdownScroll.bind(this)
    // 本次弹窗内是否已经自动填充过分析名（只自动填一次）
    this._analyzeAutoFilled = false
  },
  beforeDestroy() {
    clearTimeout(this._projectTimer)
    clearTimeout(this._analyzeTimer)
    this.removeDropdownScroll()
  },
  methods: {
    // 打开抽屉（默认先看海报）；父组件自动弹出也调用这个方法
    open(step = 'poster') {
      this.reset()
      this.step = step === 'picker' ? 'picker' : 'poster'
      this.visible = true
    },
    close() {
      this.visible = false
    },
    reset() {
      this.projectKeyword = ''
      this.projectSearchField = 'projectId'
      this.projectList = []
      this.projectPage = 1
      this.projectTotal = 0
      this.projectNoMore = true
      this.selectedProject = null
      this.neverAuto = false
      this.analyzeKeyword = ''
      this.analyzeList = []
      this.analyzePage = 1
      this.analyzeTotal = 0
      this.analyzeNoMore = true
      this.analyzeId = ''
      // 每次打开弹窗重置一次自动填充标记
      this._analyzeAutoFilled = false
      this.loading=true
      // 打开即拉第一页，下拉里直接有多条项目可选
      this.fetchProjects(true)
    },

    // ---------------- 项目：/project/page，支持按项目号或合同号远程搜索 + 滚动加载更多 ----------------
    // 切换搜索字段：清掉上一次关键词，重新拉第一页
    handleSearchFieldChange() {
      this.projectKeyword = ''
      this.fetchProjects(true)
    },
    handleProjectSearch(keyword) {
      this.projectKeyword = keyword || ''
      clearTimeout(this._projectTimer)
      this._projectTimer = setTimeout(() => this.fetchProjects(true), 300)
    },
    async fetchProjects(reset = true) {
      if (!reset && (this.projectLoading || this.projectNoMore)) return
      if (reset) {
        this.projectPage = 1
        this.projectNoMore = false
      }
      const token = ++this._projectToken
      this.projectLoading = true
      try {
        const condition = {}
        // bz 平台按系统类型过滤（多样性 / 功能基因扩增子）
        if (this.apiPlatform === 'bz') condition.systemType = this.systemType
        const keyword = (this.projectKeyword || '').trim()
        if (keyword) condition[this.projectSearchField] = keyword
        const res = await projectPageList({
          page: {current: this.projectPage, size: this.pageSize},
          condition,
          sorts: []
        }, this.apiPlatform)

        if (token !== this._projectToken) return
        const {list, total} = parsePageResult(res)
        this.projectList = reset ? list : this.projectList.concat(list)
        this.projectTotal = total
        this.projectNoMore = !list.length || this.projectList.length >= total
        // 默认填充：还没有选择项目时，自动选中第一条
        if (reset && !this.selectedProject && list.length) {
          this.selectedProject = list[0]
        }
        // 重新搜索时把下拉滚回顶部
        if (reset && this._scrollWrap && this._scrollKind === 'project') {
          this._scrollWrap.scrollTop = 0
        }
      } catch (e) {
        if (token === this._projectToken && reset) this.projectList = []
      } finally {
        if (token === this._projectToken) this.projectLoading = false
      }
    },

    // ---------------- 分析号：/analyze/page，按项目筛选，远程 + 滚动加载更多 ----------------
    handleAnalyzeSearch(keyword) {
      this.analyzeKeyword = keyword || ''
      clearTimeout(this._analyzeTimer)
      this._analyzeTimer = setTimeout(() => this.fetchAnalyzes(true), 300)
    },
    async fetchAnalyzes(reset = true) {
      if (!this.selectedProjectId) return
      if (!reset && (this.analyzeLoading || this.analyzeNoMore)) return
      if (reset) {
        this.analyzePage = 1
        this.analyzeNoMore = false
      }
      const token = ++this._analyzeToken
      this.analyzeLoading = true
      try {
        const condition = {projectId: this.selectedProjectId,execStatus: [2]}
        const keyword = (this.analyzeKeyword || '').trim()
        if (keyword) condition.analyzeId = keyword
        const res = await analyzePageList({
          page: {current: this.analyzePage, size: this.pageSize},
          condition,
          sorts: []
        }, this.apiPlatform)
        this.loading=false
        if (token !== this._analyzeToken) return
        const {list, total} = parsePageResult(res)
        this.analyzeList = reset ? list : this.analyzeList.concat(list)
        this.analyzeTotal = total
        this.analyzeNoMore = !list.length || this.analyzeList.length >= total
        // 默认填充：只在本次弹窗内第一次加载时自动选中第一条，
        // 之后换项目/搜索都不再自动改，遵循用户自己的选择
        if (reset && !this._analyzeAutoFilled && !this.analyzeId && list.length) {
          this._analyzeAutoFilled = true
          this.analyzeId = this.getAnalyzeId(list[0])
        }
        if (reset && this._scrollWrap && this._scrollKind === 'analyze') {
          this._scrollWrap.scrollTop = 0
        }
      } catch (e) {
        if (token === this._analyzeToken && reset) this.analyzeList = []
      } finally {
        if (token === this._analyzeToken) this.analyzeLoading = false
      }
    },

    // ---------------- 下拉滚动加载更多（popper 挂在 body 上，按 popper-class 查找） ----------------
    bindDropdownScroll(kind, visible) {
      if (!visible) {
        // 只解绑自己的：切换下拉时另一个下拉的关闭事件可能晚于这次的打开事件
        if (this._scrollKind === kind) this.removeDropdownScroll()
        return
      }
      this.removeDropdownScroll()
      this.$nextTick(() => {
        setTimeout(() => {
          const popperClass = kind === 'project' ? 'chat-ai-project-popper' : 'chat-ai-analyze-popper'
          const wrap = document.querySelector(`.${popperClass} .el-select-dropdown__wrap`)
          if (!wrap) return
          this._scrollKind = kind
          this._scrollWrap = wrap
          wrap.addEventListener('scroll', this._scrollHandler)
        }, 60)
      })
    },
    removeDropdownScroll() {
      if (this._scrollWrap) {
        this._scrollWrap.removeEventListener('scroll', this._scrollHandler)
      }
      this._scrollWrap = null
      this._scrollKind = ''
    },
    handleDropdownScroll(event) {
      const el = event.target
      // 距离底部 24px 内触发加载下一页
      if (el.scrollHeight - el.scrollTop > el.clientHeight + 24) return
      if (this._scrollKind === 'project') {
        if (this.projectLoading || this.projectNoMore) return
        this.projectPage += 1
        this.fetchProjects(false)
      } else if (this._scrollKind === 'analyze') {
        if (this.analyzeLoading || this.analyzeNoMore) return
        this.analyzePage += 1
        this.fetchAnalyzes(false)
      }
    },

    // ---------------- 取值 / 展示 ----------------
    getProjectId(item) {
      return (item && item.projectsRow && item.projectsRow.projectId) || ''
    },
    getContractNumber(item) {
      return (item && item.projectsRow && item.projectsRow.contractNumber) || ''
    },
    // 项目类型：不同平台字段不同（转录/多样性是 projectType，代谢/宏基因组是 projectSign）
    getProjectType(item) {
      const row = (item && item.projectsRow) || {}
      return row.projectType || row.projectSign || ''
    },
    projectLabel(item) {
      const contract = this.getContractNumber(item)
      return contract ? `${this.getProjectId(item)}（${contract}）` : this.getProjectId(item)
    },
    getAnalyzeId(item) {
      return (item && (item.analyzeId || item.id)) || ''
    },
    analyzeLabel(item) {
      return (item && (item.analyzeName || item.name || this.getAnalyzeId(item))) || ''
    },

    // ---------------- 进入智能体 / 不再提示 ----------------
    enterChatAi() {
      if (!this.canEnter) return
      const project = this.selectedProject
      const projectId = this.getProjectId(project)
      let web = (PLATFORM_INFO[this.platform] || {}).web
      // 宏基因组 v3 项目走 metagWeb_v3，和列表页跳转保持一致
      if (this.platform === 'metag' && project.version && project.version.value === 'v3') {
        web = 'metagWeb_v3'
      }
      const url = `/${web}/chatAi?projectId=${encodeURIComponent(projectId)}&analyzeId=${encodeURIComponent(this.analyzeId)}`
      window.open(url, '_blank')
      this.visible = false
    },
    handleNeverShow() {
      // 由父组件负责持久化“不再提示”，并提示用户入口位置
      this.$emit('never-show')
    },
    onNeverAutoToggle() {
      if (this.neverAuto) return
      this.neverAuto = true
      this.handleNeverShow()
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog__body{
  padding-top: 15px!important;

}
/* ---------- 弹窗 ---------- */
.ai-agent-dialog__body {
  padding: 2px 2px 4px;
}

/* ---------- 海报 ---------- */
.promo-poster {
  text-align: center;
  width: 100%;
}

.promo-poster__wrap {
  position: relative;
  display: inline-block;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 8px 28px rgba(31, 122, 224, .16);
  transition: transform .25s, box-shadow .25s;
}

.promo-poster__wrap:hover {
  transform: translateY(-3px);
  box-shadow: 0 14px 34px rgba(31, 122, 224, .28);
}

.promo-poster__img {
  display: block;
  width: 100%;
  //max-width: 100%;
  //height: 400px;
  margin: 0 auto;
}

/* 悬停时的渐变浮层 + 行动按钮，让“点这里”更醒目 */
.promo-poster__overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 48px 16px 20px;
  display: flex;
  justify-content: center;
  background: linear-gradient(180deg, rgba(15, 46, 87, 0) 0%, rgba(15, 46, 87, .55) 100%);
  opacity: 0;
  transition: opacity .25s;
}

.promo-poster__wrap:hover .promo-poster__overlay {
  opacity: 1;
}

.promo-poster__cta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 26px;
  border-radius: 22px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 2px;
  background: linear-gradient(135deg, #3f9dfe 0%, #1f7ae0 100%);
  box-shadow: 0 6px 16px rgba(31, 122, 224, .45);
  transition: transform .2s;
}

.promo-poster__wrap:hover .promo-poster__cta {
  transform: scale(1.05);
}

.promo-poster__bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin: 14px 0 2px;
}

.promo-poster__hint {
  font-size: 12px;
  color: #909399;
}

.promo-poster__hint i {
  color: #3f9dfe;
  margin-right: 2px;
}

/* ---------- 通用文字按钮（不再提示） ---------- */
.promo-link-btn {
  border: 0;
  background: transparent;
  padding: 0;
  font-size: 12px;
  color: #a0a4ab;
  cursor: pointer;
  transition: color .2s;
}

.promo-link-btn:hover {
  color: #3f9dfe;
}

/* ---------- 选择项目 / 分析 ---------- */
.promo-picker {
  padding: 0 2px;
  animation: promoFade .35s ease;
}

@keyframes promoFade {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: none; }
}

.promo-picker__head {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  margin-bottom: 30px;
  border-radius: 14px;
  overflow: hidden;
  background:
    radial-gradient(360px 140px at 90% -40%, rgba(63, 157, 254, .20), transparent 60%),
    radial-gradient(260px 120px at 4% 135%, rgba(31, 122, 224, .10), transparent 60%),
    linear-gradient(135deg, #eef6ff 0%, #f5faff 58%, #f0f7ff 100%);
  border: 1px solid #e1eefc;
}

.promo-picker__badge {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  font-size: 24px;
  color: #fff;
  background: linear-gradient(135deg, #46a3ff 0%, #1f7ae0 60%, #1a6fd0 100%);
  box-shadow: 0 8px 18px rgba(31, 122, 224, .32), inset 0 1px 0 rgba(255, 255, 255, .35);
}

.promo-picker__head-text {
  min-width: 0;
}

.promo-picker__title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  line-height: 1.3;
}
.promo-picker__img {
  width: 60px;
}
/* Pro 胶囊徽标 */
.promo-picker__pro {
  display: inline-block;
  margin-left: 7px;
  padding: 1px 9px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.6;
  color: #1f7ae0;
  background: rgba(31, 122, 224, .10);
  border: 1px solid rgba(31, 122, 224, .22);
  border-radius: 999px;
  letter-spacing: .5px;
}

.promo-picker__sub {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
}

.promo-never__box i {
  color: #fff;
  font-size: 11px;
  transform: scale(0);
  transition: transform .18s ease;
}

.promo-never.is-checked .promo-never__box {
  background: linear-gradient(135deg, #3f9dfe 0%, #1f7ae0 100%);
  border-color: #1f7ae0;
}

.promo-never.is-checked .promo-never__box i {
  transform: scale(1);
}

.promo-never:hover .promo-never__box {
  border-color: #3f9dfe;
}

/* 搜索图标前缀 */
.promo-picker__searchicon {
  font-size: 15px;
}




/* 项目：搜索字段（项目号/合同号）+ 搜索框 同一行 */
.promo-picker__search {
  display: flex;
  align-items: center;
  gap: 8px;
}

.promo-picker__field {
  width: 96px;
  flex: none;
}

.promo-picker__select {
  flex: 1;
  min-width: 0;
}

.promo-picker__form {
  margin-top:20px;
}

/* filterable + remote 模式下 Element 不渲染下拉箭头（iconClass 为空），这里补回来 */
.promo-picker__form >>> .el-select__caret.el-icon- {
  color: #c0c4cc;
}

.promo-picker__form >>> .el-select__caret.el-icon-::before {
  font-family: element-icons;
  content: "\e6e1"; /* el-icon-arrow-up，基础样式已旋转 180° 呈向下箭头 */
}

/* 展开/聚焦时箭头朝上 */
.promo-picker__form >>> .el-input.is-focus .el-select__caret.el-icon- {
  transform: rotateZ(0deg);
}

/* 有选中值悬停时显示的是清空按钮，箭头会被隐藏，这里不用管 */


.promo-picker__prefix {
  font-size: 15px;
  line-height: 36px;
  color: #3f9dfe;
}

.promo-picker__tip {
  margin-top: 4px;
  font-size: 12px;
  color: #e6a23c;
}

.promo-picker__tip i {
  margin-right: 2px;
}

/* 选项：项目号 + 合同号 + 类型 */
.promo-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.promo-option__main {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.promo-option__meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: none;
}

.promo-option__sub {
  font-size: 12px;
  color: #a0a4ab;
}

/* 类型标签 */
.promo-option__tag {
  padding: 0 6px;
  height: 18px;
  line-height: 18px;
  border-radius: 9px;
  background: #eef6ff;
  color: #2f86e8;
  font-size: 11px;
}

/* 下拉无数据 / 加载中的占位文案 */
.promo-select-empty {
  padding: 10px 0;
  font-size: 12px;
  color: #909399;
  text-align: center;
}



/* ---------- 底部 ---------- */
.promo-picker__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 25px;
}

.promo-picker__enter {
  min-width: 250px;
  height: 40px;
  border-radius: 20px;
  font-weight: 600;
  background: linear-gradient(135deg, #3f9dfe 0%, #1f7ae0 100%);
  border: none;
}
/deep/ .el-select__remote-loading {
  display: none !important;
}
</style>
